import {Model} from './model';

export class PaymentTransferStatus implements Model {
  paymentTransferStatusId: number;
  label: string;

  static copy(oldObj: PaymentTransferStatus): PaymentTransferStatus {
    const newObj = new PaymentTransferStatus();
    newObj.paymentTransferStatusId = oldObj.paymentTransferStatusId;
    newObj.label = oldObj.label;
    return newObj;
  }

  getPrimaryKey(): number {
    return this.paymentTransferStatusId;
  }

  isNew(): boolean {
    return isNaN(this.paymentTransferStatusId);
  }

  clone(): PaymentTransferStatus {
    return PaymentTransferStatus.copy(this);
  }
}

export enum PaymentTransferStatusId {
  PENDING = 0,
  SUCCESS = 2,
  FAILED = 3
}
